<template>
    <div class="progress-tracker" :class="{'d-none': step == 5 || step == 1}">
        <ul class="progress-tracker__bar">
            <li class="progress-tracker__bar-item" :class="{ current: step == 1, success: step > 1}" @click="setStep(1)" >
                <div><i class="fa fa-user"></i></div><p>Datos personales</p>
            </li>
            <li class="progress-tracker__bar-item" :class="{ current: step == 2, success: step > 2}" @click="setStep(2)">
                <div><i class="fa fa-address-card"></i></div><p>Contraseña</p>
            </li>
            <!-- <li class="progress-tracker__bar-item" :class="{ current: step == 3, success: step > 3}" @click="setStep(3)">
                <div><i class="fa fa-phone"></i></div><p>Validar teléfono</p>
            </li>
            <li class="progress-tracker__bar-item" :class="{ current: step == 4, success: step > 4}" @click="setStep(4)">
                <div><i class="fa fa-credit-card"></i></div><p>Validar método de pago</p>
            </li> -->
            <li class="progress-tracker__bar-item" :class="{ current: step == 3, success: step > 3}" @click="setStep(5)">
                <div><i class="fa fa-address-card"></i></div><p>Acceso</p>
            </li>
            <!-- <li class="progress-tracker__bar-item" :class="{ current: step == 4, success: step > 4}"><div><font-awesome-icon icon="check"/></div><p>FINALIZADO</p></li> -->
        </ul>
    </div>
</template>

<script>
  export default {
      name: 'progressTracker',
      props: ['step'],
      methods: {
          setStep(step) {
            //   this.$emit('step', step);
          }


      }
  }

</script>

<style lang="scss">
    // @import '../variables.scss';
    @import '@/assets/scss/mimoto.scss';

    .progress-tracker {
      position: relative;
      width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
        // overflow-y: hidden;
        // overflow-x: hidden;
        height: 80px;
        &__bar {
            display: flex;
            width: 100%;
            padding: 0;
            &-item {
                display: flex;
                flex: 1;
                justify-content: center;
                position: relative;
                color: #BBB;
                transition: color 0.7s ease;
                width: 50px;
                height: 50px;
                p {
                    font-family: 'Avenir', Helvetica, Arial, sans-serif;
                    font-weight: 500;
                    position: absolute;
                    font-size: 0.8rem;
                    color: #BBB;
                    top: 55px;
                    transition: color 0.7s ease;
                }
                div {
                    position: absolute;
                    width: 50px !important;
                    height: 50px;
                    border: 2px solid #BBB;
                    border-radius: (50px / 2) + 5px; // 5px fix right radius
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: border-color 0.7s ease;
                    z-index: 1;
                    background: white;
                    svg {
                        font-size: 18px;
                        transition: color 0.7s ease;
                    }
                }

                &:after {
                    content: '';
                    position: absolute;
                    height: 2px;
                    background-color: #BBB;
                    width: 100%;
                    top: calc(50% - 1px);
                    left: 50%;
                    transition: background-color 0.7s ease;
                }

                &:last-child {
                    margin-right: -5%;
                }

                &:first-child {
                    margin-left: -5%;
                }
                &:last-child:after {
                    content: none;
                }

                &.current {
                    svg {
                        color: $main-color-link-hover;
                    }
                    p {
                        color: $main-color-link-hover;
                    }
                    i {
                      color: $main-color-link-hover;
                    }
                }
                &.current div {
                    border-color: $main-color-link-hover;
                }

                &.success {
                    svg {
                        color: $main-color;
                    }
                    p {
                        color: $main-color;
                    }
                    i {
                        color: $main-color;
                    }


                }
                &.success div {
                    border-color: $main-color;
                }
                &.success:after {
                    background-color: $main-color;
                }

                @media (max-width: 575px) {
                    svg {
                        font-size: 16px;
                    }
                    p {
                        font-size: 0.6rem;
                    }
                }

                // &:hover {
                //     cursor: pointer;

                //     svg {
                //         color: $main-color-link-hover;
                //     }
                //     p {
                //         color: $main-color-link-hover;
                //     }
                //     div {
                //         border-color: $main-color;
                //     }
                // }
            }
        }
    }

</style>
